import React, { FC } from 'react';
import parse from 'html-react-parser';
import { IHero1 } from './params';
import Styles from './styles';
import { Helmet } from 'react-helmet';
import getBackgroundImageUrl from '../../../utils/getBackgroundImageUrl';
import getBackgroundImageStyles from '../../../utils/getBackgroundImageStyles';

const Hero1: FC<{ config: IHero1 }> = ({ config }) => {
  const preloadBgImage = getBackgroundImageUrl(config.backgroundImage);

  return (
    <>
      {preloadBgImage ? (
        <Helmet>
          <link rel="preload" href={preloadBgImage} as="image" />
        </Helmet>
      ) : null}

      <Styles $config={config}>
        <div className="hero" style={{ backgroundImage: `${getBackgroundImageStyles(config.backgroundImage)}` }}>
          <div className="container">
            <div className="hero-wrapper">
              <h1 className="hero-header">{parse(config.group_header.content)}</h1>
              <p className="hero-description">{parse(config.group_description.content)}</p>
            </div>
          </div>
        </div>
      </Styles>
    </>
  );
};

export default Hero1;
